import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-svg-loading-light',
  templateUrl: './svg-loading-light.component.html',
  styleUrls: ['./svg-loading-light.component.css']
})
export class SvgLoadingLightComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
